import { Layout } from "@/components/Layout";
import { AdminLayout } from "@/components/AdminLayout";
import { PaymentsManagement } from "@/components/PaymentsManagement";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CreditCard } from "lucide-react";

export default function AdminSubscriptions() {
  return (
    <AdminLayout>
      <div className="container mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold mb-1 flex items-center gap-2">
            <CreditCard className="w-6 h-6" />
            All Subscriptions & Purchases
          </h1>
          <p className="text-sm text-muted-foreground">
            Manage all subscriptions and purchases across all users
          </p>
        </div>

        <PaymentsManagement isAdmin={true} />
      </div>
    </AdminLayout>
  );
}

